// assets
import { ClipboardText } from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - ASSESSMENT DETAILS ||============================== //

const assessmentDetails: NavItemType = {
  id: 'group-assessment',
  title: 'Assessment',
  type: 'group',
  children: [
    {
      id: 'assessment-details',
      title: 'Manage Assessment',
      type: 'item',
      url: '/assessment-details',
      icon: ClipboardText,
      breadcrumbs: false
    }
  ]
};

export default assessmentDetails;
